import { CompanyContactType } from '@api';
import { CompanyContactSelectValueType } from '../../types';

export const mapContactSelectChange = (
  value: string | null,
  data: CompanyContactType[],
  onChange: (value: CompanyContactSelectValueType | null) => void
): void => {
  if (value === null) {
    onChange(null);
    return;
  }

  const contactPerson = data[Number(value)];
  if (!contactPerson) return;

  onChange({
    personId: contactPerson.personId,
    companyId: contactPerson.companyId,
  });
};
